module.exports = __webpack_public_path__ + "static/media/7.b03dcab6.jpg";